import { getBootstrapData } from "@swa-ui/bootstrap";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

const getCountryCodes = () => {
  const countriesData = getBootstrapData("countries-data");

  return countriesData?.map((country) => country.countryCode) ?? [];
};

export const COUNTRY_SCHEMA_FIELD_NAME = "countryCode";

export const getCountryFormFieldSchema = (label = i18n("CountryFormField__LABEL")) =>
  yup
    .string()
    .trim()
    .required()
    .oneOf(getCountryCodes(), i18n("CountryFormField__INVALID"))
    .label(label.toLowerCase());
